import React from "react";
import { createRoot } from "react-dom/client";
import ReviewSwiper from "./ReviewSwiper";

const rootElement = document.querySelector("#react-google-reviews");

if (rootElement) {
  const logicData = rootElement.getAttribute("data-logic");
  const locationData = rootElement.getAttribute("data-location-key");

  const root = createRoot(rootElement);
  root.render(<ReviewSwiper logic={logicData} locationData={locationData} />);
}
